// @ts-nocheck
import Lightbox, { ILightBoxProps } from 'lightbox-react'
import 'lightbox-react/style.css'
import React, { useState, useEffect } from 'react'
import useMediaQuery from '@utilities/hooks/useMediaQuery'
import useIsDesktop from '@utilities/hooks/useIsDesktop'
type Props = {
  src: string
  width?: string
  height?: string
  id?: string
  zoom?: string
  className?: string
  alt?: string
}
function ImageZoom(props: Props) {
  const [zoomed, setZoomed] = useState('1')
  const [position, setPosition] = useState('50% 50%')
  const [imgData, setImgData] = useState<string>('')
  const [lightboxOpen, setLightboxOpen] = React.useState(false)
  let figureClass = imgData ? 'loaded' : 'loading'
  let figureZoomed = zoomed === '0' ? 'zoomed' : 'fullView'
  const isDesktop = useIsDesktop()
  function zoomInPosition(e: any) {
    const zoomer = e.currentTarget.getBoundingClientRect()
    let x, y, offsetX, offsetY
    offsetX = e.clientX - zoomer.x
    offsetY = e.clientY - zoomer.y
    x = (offsetX / zoomer.width) * 100
    y = (offsetY / zoomer.height) * 100
    setPosition(`${x}% ${y}% `)
  }
  function toggleZoomImage(e: any) {
    if (zoomed === '0') {
      setZoomed('1')
    } else {
      setZoomed('0')
      zoomInPosition(e)
    }
  }
  function handleClick(e: any) {
    if (!isDesktop) {
      setLightboxOpen(true)
      return
    }
    toggleZoomImage(e)
  }
  function handleMove(e: any) {
    if (zoomed === '0') {
      zoomInPosition(e)
    }
  }
  function handleLeave() {
    setZoomed('1')
    setPosition('50% 50%')
  }
  useEffect(() => {
    if (props.src === '' || props.src == null) {
      throw new Error(
        'Prop src must be defined when using ImageZoom component!'
      )
    }
    setZoomed('0')
    let img = new Image()
    img.src = props.src
    img.addEventListener('load', () => {
      setTimeout(() => {
        setZoomed('1')
        setImgData(img?.src)
      }, 200)
    })
  }, [])

  return (
    <>
      {lightboxOpen && (
        <Lightbox
          mainSrc={imgData || ''}
          clickOutsideToClose
          width={props?.width}
          height={props?.height}
          onCloseRequest={() => setLightboxOpen(false)}
        />
      )}
      <div
        id={props?.id}
        className={[figureClass, figureZoomed, props?.className].join(' ')}
        style={{
          backgroundImage: zoomed === '0' ? 'url(' + imgData + ')' : '',
          backgroundSize: props?.zoom + '%',
          backgroundPosition: position,
        }}
        onClick={(e) => handleClick(e)}
        onMouseMove={(e) => handleMove(e)}
        onMouseLeave={() => handleLeave()}
      >
        <img
          id="imageZoom"
          src={imgData || ''}
          alt={props?.alt}
          style={{
            opacity: zoomed,
            cursor: zoomed === '1' ? 'zoom-in' : 'zoom-out',
            minHeight: 300,
            height: '100%',
            objectFit: 'cover',
          }}
          width={props?.width}
          height={props?.height}
        />
      </div>
    </>
  )
}
ImageZoom.defaultProps = {
  zoom: '200',
  alt: 'This is an imageZoom image',
  width: '100%',
  height: 'auto',
}
export default ImageZoom
